import { Children, PropsWithChildren, ReactElement, cloneElement, useEffect, useRef, useState } from 'react';
import { register } from 'swiper/element/bundle';
import { SwiperProps } from "swiper/react";
import 'swiper/swiper-bundle.css';
import Container from '../Grid/Container';
import Row from '../Grid/Row';
import Column from '../Grid/Column';

register();

const LatestMaterialSlider = ({ children }: PropsWithChildren) => {
    const swiperRef = useRef() as any;
    const arrayChildren = Children.toArray(children);

    useEffect(() => {
        const swiperContainer = swiperRef.current;

        if (!swiperContainer) return;

        const params: SwiperProps = {
            speed: 750,
            breakpoints: {
                3500: {
                    slidesPerView: 6.8,
                },
                2500: {
                    slidesPerView: 4.8,
                },
                1400: {
                    slidesPerView: 3.8,
                },
                769: {
                    slidesPerView: 2.5,
                },
                500: {
                    slidesPerView: 1.9,
                },
                0: {
                    slidesPerView: 1.3,
                },
            },
            spaceBetween: 24,
            loop: true,
            navigation: {
                prevEl: '.latest-material-prev-slide-btn',
                nextEl: '.latest-material-slide-btn',
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, [swiperRef])

    const itemRefs = useRef<HTMLParagraphElement[]>([]);
    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        if (itemRefs.current.length > 0) {
            const heights = itemRefs.current.map((ref) => ref?.offsetHeight || 0);
            setMaxHeight(Math.max(...heights));
        }
    }, [children]);

    const registerRef = (el: HTMLParagraphElement) => {
        if (el && !itemRefs.current.includes(el)) {
            itemRefs.current.push(el);
        }
    };


    return (
        <>
            <swiper-container ref={swiperRef} init={false} navigation>
                {arrayChildren.map((child, i) => (
                    <swiper-slide key={i}>
                        {cloneElement(child as ReactElement, { setRef: registerRef, maxHeight })}
                    </swiper-slide>
                ))}
            </swiper-container>
            <div className="flex mt-8 gap-x-8 items-center">
                <button type='button' className='border-[2px] border-accordorange rounded-full p-4 latest-material-prev-slide-btn'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M24.7352 34.7582C24.3897 35.0877 23.8381 35.0794 23.5031 34.7396L10.7374 21.7901C9.75419 20.7927 9.75419 19.2073 10.7374 18.2099L23.5031 5.26045C23.8381 4.9206 24.3897 4.91225 24.7352 5.2418C25.0807 5.57134 25.0892 6.11399 24.7542 6.45384L11.9886 19.4033C11.6608 19.7358 11.6608 20.2642 11.9886 20.5967L24.7542 33.5462C25.0892 33.886 25.0807 34.4287 24.7352 34.7582Z" fill="#E8EEF2" />
                    </svg>
                </button>
                <button type='button' className='border-[2px] border-accordorange rounded-full p-4 latest-material-slide-btn'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M15.2648 5.2418C15.6103 4.91225 16.1619 4.9206 16.4969 5.26045L29.2626 18.2099C30.2458 19.2073 30.2458 20.7927 29.2626 21.7901L16.4969 34.7396C16.1619 35.0794 15.6103 35.0877 15.2648 34.7582C14.9193 34.4287 14.9108 33.886 15.2458 33.5462L28.0114 20.5967C28.3392 20.2642 28.3392 19.7358 28.0114 19.4033L15.2458 6.45384C14.9108 6.114 14.9193 5.57135 15.2648 5.2418Z" fill="#E8EEF2" />
                    </svg>
                </button>
            </div>
        </>
    )
}

export default LatestMaterialSlider;